<div class="mb-4">
  <responsible-client-edit-form
    (response)="responseForm($event)"
    [editItem]="item"
    [idPerson]="idPerson"
  ></responsible-client-edit-form>
</div>

<div>
  @if (!loading) {
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (column.key.edit) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="edit"
                      (click)="updateItem(element)"
                    />
                  }
                  <!--                  @if (column.key.delete) {-->
                  <!--                    @if (tableSource.data.length > 1) {-->
                  <!--                      <mat-icon-->
                  <!--                        class="btn-icon-outline"-->
                  <!--                        fontIcon="delete"-->
                  <!--                        (click)="deleteItem(element)"-->
                  <!--                      />-->
                  <!--                    } @else {-->
                  <!--                      <mat-icon-->
                  <!--                        class="btn-icon-outline disabled"-->
                  <!--                        fontIcon="delete"-->
                  <!--                      />-->
                  <!--                    }-->
                  <!--                  }-->
                </div>
              } @else if (column.keyColumn == 'phone') {
                {{ element[column.key] | telefone }}
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  <mat-paginator
    [hidden]="loading"
    #paginator
    [pageSize]="5"
    (page)="pageChanged($event)"
  >
  </mat-paginator>
</div>
